import { render, staticRenderFns } from "./notify-cancellation-card.component.vue?vue&type=template&id=5f4ddd4d&scoped=true&"
import script from "./notify-cancellation-card.component.vue?vue&type=script&lang=ts&"
export * from "./notify-cancellation-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./notify-cancellation-card.component.vue?vue&type=style&index=0&id=5f4ddd4d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ddd4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
